import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  PaymentActionError,
  PaymentActionResult,
  ProcessPaymentPayload,
} from '@cashier/cashier-model';

export interface PaymentProcessingState {
  result: PaymentActionResult;
  error: null | PaymentActionError;
}

export const PAYMENT_PROCESSING_FEATURE_KEY = 'paymentProcessing';

export const initialPaymentProcessingState: PaymentProcessingState = {
  result: {
    status: '',
    resultAction: null,
    description: '',
    transactionId: '',
    paymentAttributes: [],
  },
  error: null,
};

export const paymentProcessingSlice = createSlice({
  name: PAYMENT_PROCESSING_FEATURE_KEY,
  initialState: initialPaymentProcessingState,
  reducers: {
    resetStore: (state) => {
      state.result = {
        ...initialPaymentProcessingState.result,
      };
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    initiateProcessing: (_) => {},
    processPaymentStart: (
      _,
      __: PayloadAction<ProcessPaymentPayload>,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
    ) => {},
    processPaymentSuccess: (
      state,
      action: PayloadAction<PaymentActionResult>,
    ) => {
      state.result = action.payload;
    },
    processPaymentFailure: (
      state,
      action: PayloadAction<PaymentActionError>,
    ) => {
      state.error = action.payload;
    },
  },
});

export const paymentProcessingReducer = paymentProcessingSlice.reducer;

export const {
  initiateProcessing,
  processPaymentStart,
  processPaymentSuccess,
  processPaymentFailure,
} = paymentProcessingSlice.actions;
